import React from 'react';
import Button from '../Button';
import styles from '../../styles/test/TestStyles.module.css';

const ConfirmAbandonModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>¿Seguro que quieres abandonar?</h3>
        <p className={styles.modalText}>
          Si abandonas el test, perderás todo tu progreso actual y las respuestas no se guardarán.
        </p>
        <div className={styles.modalButtons}>
          <Button
            variant="error"
            onClick={onConfirm || onClose}
            aria-label="Confirmar y abandonar el test"
            className={styles.abandonButton}
          >
            ABANDONAR
          </Button>
          <Button
            variant="neutral"
            onClick={onClose}
            aria-label="Cancelar y continuar con el test"
            className={styles.continueButton}
          >
            CONTINUAR TEST
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAbandonModal;